export default __webpack_public_path__ + "static/media/section-1.eaa7c6c2.jpg";